export default __webpack_public_path__ + "static/media/6.e583b625.svg";